import { render, staticRenderFns } from "./newstore.vue?vue&type=template&id=24278b08&scoped=true&"
import script from "./newstore.vue?vue&type=script&lang=js&"
export * from "./newstore.vue?vue&type=script&lang=js&"
import style0 from "./newstore.vue?vue&type=style&index=0&id=24278b08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24278b08",
  null
  
)

export default component.exports